<template>
    <basic-modal @hide="close"
                 v-model="opened"
                 aria-label="Create Export"
                 role="dialog"
    >
        <div slot="header">
            <basic-modal-close-button ref="closeButton"></basic-modal-close-button>
            <h3 class="modal-title">Create Export</h3>
        </div>
        <div>
            <label for="report-name">Export Name</label>
            <input id="report-name" class="form-control" maxlength="127" v-model="reportName"/>
        </div>
        <div class="margin-15-top">
            <span>Include</span>
            <tree-select v-model="selectedItems" :multiple="true" :options="sectionsToSelect"/>
        </div>
        <div class="margin-15-top">
            <vue-switch-with-label label="Show full logs" name="show_full_logs" v-model="includeFullLog"/>
        </div>
        <div slot="footer">
            <div class="row">
                <div class="col-sm-12">
                    <button @click="close" type="button" class="btn btn-mm  btn-primary">Cancel</button>
                    <button @click="createReport" :disabled="createDisabled" type="button"
                            class="btn btn-mm  btn-green">
                        Create
                    </button>
                </div>
            </div>
        </div>
    </basic-modal>
</template>

<script>
    import moment from 'moment';
    import BasicModal from '~/vue/common_components/BasicModal.vue';
    import BasicModalCloseButton from '~/vue/common_components/BasicModalCloseButton.vue';
    import PopupPromiseMixin from '~/vue/mixins/PopupPromiseMixin';
    import TreeSelect from '@riophae/vue-treeselect';

    const TIME_ZONE = 'Europe/London';
    const TODAY = moment.tz(TIME_ZONE).toDate();
    const VISUAL_DATE_FORMAT = 'DD/MM/YYYY';
    const REPORT_NAME_DATE_FORMAT = 'YYYY-MM-DD';

    export default {
        name: 'CreateWikiReportPupup',
        mixins: [PopupPromiseMixin],
        components: {
            TreeSelect,
            BasicModalCloseButton,
            BasicModal
        },
        data() {
            return {
                sectionsToSelect: [],
                selectedItems: [],
                reportName: '',
                includeFullLog: false
            };
        },
        computed: {
            createDisabled() {
                return !(this.reportName && this.selectedItems.length);
            },
        },
        methods: {
            setInitial(sectionsToSelect) {
                this.sectionsToSelect = sectionsToSelect;
                this.reportName = this.suggestName();
            },
            suggestName() {
                let name = `Export `;
                name += `${moment(TODAY).format(REPORT_NAME_DATE_FORMAT)}`;
                return name.slice(0, 60);
            },
            async createReport() {
                this.save({
                    reportName: this.reportName,
                    selectedItems: this.selectedItems,
                    includeFullLog: this.includeFullLog
                });
            }
        },
    };
</script>

<style scoped lang="scss">
  @import "../../styles/const.scss";

  ::v-deep {
    .vue-treeselect__multi-value-item {
      cursor: pointer;
      display: inline-table;
      background: $color-header;
      padding: 0 5px;
      border: 1px solid transparent;
      border-radius: 2px;
      color: #000000;
      font-size: 14px;
      vertical-align: top;
    }

    .vue-treeselect__control {
      height: 34px;
    }

    .vue-treeselect__option-arrow {
      width: 9px;
      height: 9px;
      color: #333;
    }

    .vue-treeselect--branch-nodes-disabled .vue-treeselect__option:hover .vue-treeselect__option-arrow {
      color: #333;
    }

    .vue-treeselect__option-arrow-container:hover .vue-treeselect__option-arrow,
    .vue-treeselect--branch-nodes-disabled .vue-treeselect__option:hover .vue-treeselect__option-arrow {
      color: #333;
    }

    .vue-treeselect__value-remove {
      color: $footer-red;
      border-left: none;

      & > svg {
        width: 8px;
        height: 8px;
      }
    }
  }
</style>
